import { type PayloadAction, createSlice } from '@reduxjs/toolkit';

import { type User, type UserInfo } from '../types/user';

interface AuthStore {
  user: User | null;
  userInfo: UserInfo | null;
  optOutStatus: boolean;
  isIntroPrice: boolean;
}

const initialState: AuthStore = {
  user: null,
  userInfo: null,
  optOutStatus: false,
  isIntroPrice: true,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setUser(state, { payload }: PayloadAction<NonNullable<AuthStore['user']>>) {
      state.user = payload;
    },
    logOut() {
      // This is handled by `rootReducer`.
    },
    setPhotoUrl(
      state,
      { payload }: PayloadAction<NonNullable<AuthStore['user']>['photoUrl']>,
    ) {
      if (state.user !== null) {
        state.user.photoUrl = payload;
      }
    },
    setUserInfo(
      state,
      { payload }: PayloadAction<NonNullable<AuthStore['userInfo']>>,
    ) {
      state.userInfo = payload;
    },
    setOptOutStatus(state, { payload }: PayloadAction<boolean>) {
      state.optOutStatus = payload;
    },
    setIsIntroPrice(state, { payload }: PayloadAction<boolean>) {
      state.isIntroPrice = payload;
    },
  },
});

export const {
  setUser,
  logOut,
  setPhotoUrl,
  setUserInfo,
  setOptOutStatus,
  setIsIntroPrice,
} = authSlice.actions;
export const authReducer = authSlice.reducer;

export const selectAuth = (state: { auth: AuthStore }): AuthStore => state.auth;
export const selectIsIntroPrice = (state: { auth: AuthStore }): boolean =>
  state.auth.isIntroPrice;
